import React from 'react';
import PropTypes from 'prop-types';
import { Link } from "react-router";
import { getFeatureFlagWithDefault } from '../featureFlags';

/**
 * Salesforce Support Center-aware link component that conditionally renders a react-router Link or anchor tag
 * based on the link destination and the feature flag value for Salesforce navigation.
 * An regular anchor tag is used for full page reloads to ensure proper navigation with the reverse-proxy setup
 * @param {Object} param0 - Component props.
 * @param {string} param0.to - The target URL for the link.
 * @returns {JSX.Element} The rendered link or anchor tag.
 */
export const SalesforceAwareLink = ({ to, ...props}) => {
  const salesforceNavigationEnabled = getFeatureFlagWithDefault("support_center_salesforce_navigation", false);

  // define the routes that should be navigated as a full page reload
  const fullPageRoutes = ["/"];

  const requiresFullPageReload = salesforceNavigationEnabled && fullPageRoutes.includes(to);

  if (requiresFullPageReload) {
    return <a href={to} {...props} />;
  }
  return <Link to={to} {...props} />;
};

SalesforceAwareLink.propTypes = {
  to: PropTypes.string
};
